import { Component, effect } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ConsumptionHubService } from '../../services/consumption-hub.service';

@Component({
  selector: 'app-auth-section',
  templateUrl: './auth-section.component.html'
})
export class AuthSectionComponent {
  status = '';
  statusClass = '';
  signingIn = false;

  constructor(
    public auth: AuthService,
    private hub: ConsumptionHubService
  ) {
    // Re-run whenever the auth signal changes (e.g. after OAuth callback saves tokens)
    effect(() => {
      if (this.auth.authenticated()) {
        this.setStatus('Signed in.', 'success');
      } else {
        this.setStatus('Not signed in.', 'error');
      }
    });
  }

  async signIn(): Promise<void> {
    this.signingIn = true;
    this.setStatus('Starting sign in…');
    try {
      await this.auth.startAuthFlow();
      // Page will redirect — status won't be seen
    } catch (error: any) {
      this.setStatus(`Error: ${error.message}`, 'error');
      this.signingIn = false;
    }
  }

  async copyToken(): Promise<void> {
    const token = this.auth.getAccessToken();
    if (token) {
      await navigator.clipboard.writeText(token);
      this.setStatus('Access token copied to clipboard.', 'success');
    } else {
      this.setStatus('No token stored. Please sign in first.', 'error');
    }
  }

  signOut(): void {
    this.auth.signOut();
    this.setStatus('Signed out. Tokens cleared.', 'success');
  }

  private setStatus(text: string, type: 'success' | 'error' | '' = ''): void {
    this.status = text;
    switch (type) {
      case 'success': this.statusClass = 'status-ok'; break;
      case 'error': this.statusClass = 'status-error'; break;
      default: this.statusClass = ''; break;
    }
  }
}
